import s from './before-after.module.css'
import { closest, toArray } from '@nrk/dh-basis-common'

function clamp(value) {
  return Math.max(Math.min(value, 100), 0)
}

export default class BeforeAfter extends HTMLElement {
  _value = 50
  connectedCallback() {
    this.input.addEventListener('change', this._handleChange)
    this.input.addEventListener('input', this._handleChange)
    if (this._isTouchDevice()) {
      this.input.addEventListener('touchstart', this._handleTouch)
      this.input.addEventListener('touchmove', this._handleTouch)
      this.input.addEventListener('touchend', this._handleTouch)
    }
    this._updateValue()

    if (this._isFullWidth() || this._isFeatureCover()) {
      const images = toArray(this.querySelectorAll('img'))
      images.forEach((image) => {
        image.setAttribute('sizes', '100vw')
      })
    }
  }

  disconnectedCallback() {
    this.input.removeEventListener('change', this._handleChange)
    this.input.removeEventListener('input', this._handleChange)
    if (this._isTouchDevice()) {
      this.input.addEventListener('touchstart', this._handleTouch)
      this.input.addEventListener('touchmove', this._handleTouch)
      this.input.addEventListener('touchend', this._handleTouch)
    }
  }

  _isTouchDevice() {
    return typeof document !== 'undefined' && 'ontouchstart' in document.documentElement
  }

  _isFullWidth() {
    const remoterendered = closest(this, '.remoterenderedcontent-reference')
    return remoterendered && remoterendered.classList.contains('fc')
  }

  _isFeatureCover() {
    const cover = closest(this, '.article-feature__cover')
    return !!cover
  }

  _updateValue() {
    this.input.value = `${this._value}`
    this.beforeElement.style.width = `${this._value}%`
    this.button.style.left = `${this._value}%`
  }

  _handleChange = (e) => {
    this._value = e.target.value
    this._updateValue()
  }

  _handleTouch = (e) => {
    const touch = e.changedTouches[0]
    const rect = this.getBoundingClientRect()
    const percent = (100 * (touch.clientX - rect.left)) / rect.width
    this._value = clamp(percent)
    this._updateValue()
  }

  get input() {
    return this.querySelector('input')
  }

  get beforeElement() {
    return this.querySelector(`.${s.before}`)
  }

  get button() {
    return this.querySelector(`.${s.sliderButton}`)
  }
}
